import '../index.css';

const features = [
  { icon: '<img src="https://static.lumi.new/60/60728471072c164fd33d49904fa6edf6.webp" alt="Lovable" style="width: 140px; height: auto; display: block; margin: 0 auto;" />', title: 'Remove Marca D\'agua', desc: 'Remove a marca d\'agua "Edit with Lovable" dos projetos' },
  { icon: '📎', title: 'Anexar Arquivos', desc: 'Anexe qualquer tipo de arquivo: imagens, PDFs, documentos, planilhas e muito mais' },
  { icon: '🧠', title: 'Melhorar Prompt com IA', desc: 'Melhorador inteligente que otimiza seus prompts automaticamente' },
  { icon: '💬', title: 'Chat da Extensão', desc: 'Interface flutuante que funciona em qualquer tela' },
  { icon: '🎤', title: 'Digitação por Voz', desc: 'Dite seus prompts por voz e a extensão transcreve automaticamente para texto' },
];

export default function Features() {
  return (
    <section className="features-section">
      <div className="section-inner">
        <h2 className="section-title">
          <span className="title-icon">&#128161;</span> Funcionalidades da Extensao
        </h2>
        <p className="section-subtitle">Tudo que voce precisa para dominar o Lovable</p>

        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" dangerouslySetInnerHTML={{ __html: f.icon }}></div>
              <h3 className="feature-title">
                {f.title}
              </h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
